module.exports = __webpack_public_path__ + "img/Assistant2.da7ece23.png";